import { addParamsToUrl, CommunicationFilterService, CommunicationService } from '@/imports-files/components/model/communication-filter';


export class CommunicationFilterAction
{
  constructor(router, setCommunicationFilter, communicationFilter, setFlagForRerender, setCommunicationList, formRef)
  {
     this.router = router
     this.setCommunicationFilter = setCommunicationFilter
     this.communicationFilter = communicationFilter
     this.setFlagForRerender = setFlagForRerender
     this.setCommunicationList = setCommunicationList;
     this.communicationService = new CommunicationService();
     this.communicationFilterService = new CommunicationFilterService();
     this.formRef = formRef
  }

  closeModal()
  {
    this.communicationFilter.state = false;
    this.setCommunicationFilter(this.communicationFilter);
    this.setFlagForRerender(Math.random()* 1000);
  }

  async resetForm()
  {
    let params_list = this.router.query;
    delete params_list.job_title;
    delete params_list.candidate_name;
    delete params_list.non_interview;
    delete params_list.important;
    addParamsToUrl(params_list, this.router)
    this.formRef.current.resetForm()
    let result = await this.communicationService.getCommunicationData(params_list)
    this.setCommunicationList(result.data)
    this.setFlagForRerender(Math.random()* 1000)
    this.closeModal();
  }

  async submitForm(values)
  {
    let params_list = this.router.query;
    delete params_list.job_title;
    delete params_list.candidate_name;
    delete params_list.non_interview;
    delete params_list.important;

    for(let key of Object.keys(values))
    {
      if(values[key] == '')
      {
         delete values[key]
      }
    }

    params_list = {...params_list, ...values};
    addParamsToUrl(params_list, this.router)
    let result = await this.communicationService.getCommunicationData(params_list)
    this.setCommunicationList(result.data)
    this.setFlagForRerender(Math.random()* 1000)
    this.closeModal();
  }

  async getDropdownOptions()
  {
      // let job_options =  await this.getJobOptions()
      // let candidate_options =  await this.getCandidateNameptions();
      let job_and_candidate_listing = await this.getCandidateAndJobNameOptions();
      return {job_options: job_and_candidate_listing.job_options, candidate_options: job_and_candidate_listing.candidate_list}
  }

  async getJobOptions()
  {
      let job_options = await this.communicationFilterService.get_job_options();
      return job_options;
  }

  async getCandidateAndJobNameOptions()
  {
    let params = {email_type: this.router.query.email_type}
    let options = await this.communicationFilterService.get_candidate_job_options(params);
    return {job_options: this.finalArrayOf(options.data.job_titles), candidate_list: this.finalArrayOf(options.data.candidate_names)};
  }

  finalArrayOf(values){
    var emptyArray = []
    values.map((x) => emptyArray.push({label: x, value: x}))
    return emptyArray;
  }

   async getCandidateNameptions()
  {
    let candidate_options = await this.communicationFilterService.get_candidate_options()
     return candidate_options;
  }

  handleCheckboxChange(name,event)
  {
    this.formRef.current.setFieldValue(name, event.target.checked)
  }

  handleDropdownChange(name, value)
  {
    this.formRef.current.setFieldValue(name, value.value)
  }

    isFilterApplied()
    {
        var previous_filter  =  this.router.query
        return previous_filter?.job_title || previous_filter?.candidate_name || previous_filter?.non_interview || previous_filter.important;
    }

  setDefaultValueDropdown(options, value)
  {
      let hash = '';
      for(let element of options)
      {
        if(element.value == value )
        {
          hash = element
          break;
        }
      }
      return hash.value;
  }
}